module.exports = __webpack_public_path__ + "img/sum-sova.c9575d48.png";